
/// <amd-module name="Search/Shared/Components/TimeoutComponent/TimeoutComponent.Props" />
export interface ITimeoutComponentProps {
    timeout: number;
}

export interface ITimeoutComponentState {
    renderInner: boolean;
}
